module.exports = __webpack_public_path__ + "static/media/fullscreen-exit.a81d00a7.svg";